import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { RootService } from '../../../service/root.service';
import { ConfirmationService } from 'primeng/primeng';
import { ToastService } from '../../../service/toast.service';
import { MFields } from '../shared/project';
import * as _ from 'lodash';
@Component({
  selector: 'listP',
  templateUrl: './listP.component.html',
  styleUrls: ['./listP.component.scss']
})
export class ListPComponent implements OnInit {
  @Input() fields;

  langBtn = 'en';
  filterVTip="[{ key: 'pId', type: 'select', value: { _id: 1 } }]";
  constructor(public rootService: RootService, public confirmationService: ConfirmationService) { }

  removeField(i, popover) {

    this.confirmationService.confirm({
      message: "wanna delete the field",
      header: "delete",
      icon: 'fa fa-trash',
      accept: () => {
        this.fields.splice(i, 1);
        popover.hide();
      }
    });
    // var r = confirm("wanna delete the field");
    // if (r == true) {
    //             this.fields.splice(i,1);
    //             popover.hide();
    // }


  }

  duplicateField(field:MFields){

    // let newField = Object.assign({},field);
    let newField = _.cloneDeep(field);
    this.fields.push(newField);

  }
  showPopover($event, popover) {

    popover.show($event);
  }
  addLangValue(v, options) {

    if (v.target.value != "") {
      var res = v.target.value.split(",");
      var i = 1;
      res.forEach(element => {
        options.push({ "_id": i, "label": element.trim() });
        i++;
      });
    }
  }

  //To copy options to Clipboard
  copyOptions(options) {
    var temp = '';
    options.forEach(v => {
      temp += ',' + v.label;
    });

    // console.log(temp.substr(1));

    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (temp.substr(1)));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    this.rootService.toast.showSuccess('Copied to Clipboard','Options');
  }
  DBItems = [
    { "name": "text" },
    { "name": "textarea" },
    { "name": "richText" },
    { "name": "email" },
    { "name": "select" },
    { "name": "multiSelect" },
    { "name": "date" },
    { "name": "img" },
    { "name": "file" },
    { "name": "integer" },
    { "name": "number" },
    { "name": "currency" },
    { "name": "cprs" },
    { "name": "phone" },
    { "name": "trn" },
    { "name": "yes-no" },
    { "name": "password" },
    { "name": "regex" },
    { "name": "address" },
    { "name": "lang" },
    { "name": "mediaGallery" },
    { "name": "ref" }
  ];

  addOption(options: Array<any>) {
    options.push({ "_id": "", "label": "" });
  }
  removeOption(options: Array<any>, index) {
    options.splice(index, 1)
  }

  setFieldName(field,fieldsName) {

    let name = '';
    if (fieldsName.length > 0) {
      fieldsName = fieldsName.charAt(0).toLowerCase() + fieldsName.slice(1);
        // replacing space with _
        var re = /\s/;
        fieldsName = fieldsName.replace(re, "_");
        fieldsName = fieldsName.replace(/[&\/\\#,+()$~%.'":*?<>{}@!^]/g,  "");

    }
    // console.log(fieldsName, name);
    field.name = fieldsName;
}

setTable(field,type){
  if(type == 'mediaGallery'){
    field.select.table= 'gallery';
    field.select.static= false;
  }
}
  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/module/project/listP/listP.component.ts